/* eslint-disable import/first */
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { EventEmitter } from "eventemitter3";
import vConsole from 'vconsole';


import { initDateFunc } from "./utils/date";
import docCookies from "./utils/cookie";
import "./index.css";
import { Local, getUrlParams, getUrlParameterByName, Session } from './utils';
import API from './api'

import asyncComponent from './async-component'

import { LOCAL_KEYS, PageComponent } from './page-component'
import store from "./store";
import moment from "moment";


const App = asyncComponent(() => import('./containers/app'))
const LoginContainer = asyncComponent(() => import('./containers/login'))
const Setting = asyncComponent(() => import('./containers/setting'))
const RoomList = asyncComponent(() => import('./containers/room-list'))
const CitySelect = asyncComponent(() => import('./containers/city-select'))
const ChainDetail = asyncComponent(() => import('./containers/chain-detail'))
const QAContainer = asyncComponent(() => import('./containers/qa'))
const XdollarContainer = asyncComponent(() => import('./containers/xdollar'))
const InvoiceListContainer = asyncComponent(() => import('./containers/invoice-list'))
const InvoiceIssuingContainer = asyncComponent(() => import('./containers/invoice-issuing'))
const InvoiceInfoContainer = asyncComponent(() => import('./containers/invoice-info'))
const InvoiceReceiverContainer = asyncComponent(() => import('./containers/invoice-receiver'))
const InvoiceHistoryContainer = asyncComponent(() => import('./containers/invoice-history'))
const InvoiceDetailContainer = asyncComponent(() => import('./containers/invoice-detail'))
const RoomDetail = asyncComponent(() => import('./containers/room-detail'))
const Book = asyncComponent(() => import('./containers/book'))
const ChainBook = asyncComponent(() => import('./containers/chain-book'))
const LeaseBook = asyncComponent(() => import('./containers/lease-book'))
const RecognitionList = asyncComponent(() => import('./containers/recognition-list')) // 验证选择列表页
// const IdcardRecognition = asyncComponent(()=> import( './containers/idcard-recognition'))
// const FaceRecognition = asyncComponent(()=> import( './containers/face-recognition'))
const MainRecognition = asyncComponent(() => import('./containers/main-recognition')) // 大陆居民身份验证页面
const OtherRecognition = asyncComponent(() => import('./containers/other-recognition')) // 港澳台/外籍人士身份验证页面
const AddGuest = asyncComponent(() => import('./containers/add-guest'))
const Delicious = asyncComponent(() => import('./containers/delicious'))
const TravelGuideList = asyncComponent(() => import('./containers/travel-guide-list'))
const RoomTypeDetail = asyncComponent(() => import('./containers/room-type-detail'))
const OrderDetail = asyncComponent(() => import('./containers/order-detail'))
const CouponsContainer = asyncComponent(() => import('./containers/coupons'))
const FeedbackContainer = asyncComponent(() => import('./containers/feedback'))
const ResetPasswordContainer = asyncComponent(() => import('./containers/reset-password'))
const OpenDoorContainer = asyncComponent(() => import('./containers/open-door'))
const SystemUpgrade = asyncComponent(() => import('./containers/system-upgrade'))
const OrderEvaluation = asyncComponent(() => import('./containers/order-evaluation'))
const CleanEvaluation = asyncComponent(() => import('./containers/clean-evaluation'))
const ApplyForClean = asyncComponent(() => import('./containers/apply-for-clean'))
const CheckinerList = asyncComponent(() => import('./containers/checkiner-list'))
const MyPresent = asyncComponent(() => import('./containers/my-present'))
const MyPoster = asyncComponent(() => import('./containers/my-poster'))
const PresentReceiver = asyncComponent(() => import('./containers/present-receiver'))
const IFrameContainer = asyncComponent(() => import('./containers/iframe-container'))
const GroundPromotionContainer = asyncComponent(() => import('./containers/ground-promotion'))
const XbedMaker = asyncComponent(() => import('./containers/xbed-maker'))

const RoomerArticle = asyncComponent(() => import('./containers/roomer-article'))

const PathFind = asyncComponent(() => import('./containers/path-find'))

const NoOne = asyncComponent(() => import('./containers/no-one'))

import Alert from "./components/alert";
import Loading from "./components/loading";
import Toast from "./components/toast";


// 配置事件监听方法
const setupEventEmitter = () => {
  window.eventEmitter = new EventEmitter();
}

// 获取推荐人ID（popularize），保存在session storage里面
const setupInspectPopularize = () => {

  const popularize = getUrlParameterByName('popularize')
  if (popularize) {
    Session.set('popularize', popularize)
  }
}

// 初始化vconsole
const setupVconsole = () => {
  if (process.env.REACT_APP_VCONSOLE === "true") {
    window.vConsole = new vConsole();
  }
}

// 配置fundebug
const setupFundebug = () => {
  if (process.env.REACT_APP_FUNDEBUG_ENABLED === "true") {
    const fundebug = require('fundebug-javascript')
    fundebug.apikey = process.env.REACT_APP_FUNDEBUG_APIKEY
    fundebug.filters = [ 
      {
        req:
        {
          url: 'https://gate.xbed.com.cn/api/wechat/jsapiTicket',
          status: /^0$/
        }
      },
      {
        name:'/caught error/'
      },
      {
        name: /^ReferenceError$/,
        message: /WeixinJSBridge is not defined/
      },
      // 过滤图片加载错误
      {
        target:
        {
          tagName: /^IMG$/,
          status: "404"
        },
        target:
        {
          tagName: /^IMG$/,
          status: "inexistence"
        }
      }
    ]
    // fundebug.silent = process.env.REACT_APP_FUNDEBUG_SILENT === "true"
    // fundebug.silentConsole =  process.env.REACT_APP_FUNDEBUG_SILENT === "true"
    fundebug.appversion = process.env.REACT_APP_VERSION
    fundebug.releasestage = process.env.REACT_APP_FUNDEBUG_RELEASESTAGE
  }
}

// 初始化openId
const initWechatOpenID = (originUrl) => {
  return new Promise(async (resolve) => {
    const openId = docCookies.getItem('openId');
    // 如果存在了openId就不去获取了
    if (openId) {
      resolve()
    }

    let { code } = getUrlParams();
    if (code) {
      try {
        let data = (await API.getWechatOpenId(code)).data
        if (data.retCode) {
          console.error('根据code获取用户openId 接口返回正常错误信息', data)
        } else {
          // key value 过期时间（永不过期） path
          docCookies.setItem('openId', data, Infinity, '/')
        }
      } catch (error) {
        console.error('根据code获取用户openId 接口错误', error)
      }
      resolve()
    } else {
      try {
        let data = (await API.getWechatCodeUrl(originUrl)).data
        if (data.retCode) {
          console.error('根据安全域名获取带code的url 接口返回正常错误信息', data)
        } else {
          window.location.href = data;
        }
      } catch (error) {
        console.error("根据安全域名获取带code的url 接口错误", error);
      }
      resolve()
    }
  })
}

// 兼容Object.values
/* if (!Object.values) {
  Object.prototype.values = (object) => {
    let valArr = [];
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        valArr.push(object[key]);
      }
    }
    return valArr
  }
} */

if (!Object.values) Object.values = function (obj) {
  if (obj !== Object(obj))
    throw new TypeError('Object.values called on a non-object');
  var val = [], key;
  for (key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      val.push(obj[key]);
    }
  }
  return val;
}


const renderApp = () => {
  return new Promise((resolve) => {
    ReactDOM.render(
      <Provider store={store}>
        <div>
          <BrowserRouter >
            <Switch>

              <Redirect path="/" exact to={{ pathname: "/app/home" }} />
              <Route path="/app/:pathname" component={App} />
              <Route path="/login" component={LoginContainer} />
              <Route path="/setting" component={Setting} />
              <Route path="/list" component={RoomList} />
              <Route path="/city-select" component={CitySelect} />
              <Route path="/qa" component={QAContainer} />
              <AuthRoute path="/xdollar" component={XdollarContainer} />
              <AuthRoute path="/invoice-list" component={InvoiceListContainer} />
              <AuthRoute path="/invoice-issuing" component={InvoiceIssuingContainer} />
              <AuthRoute path="/invoice-info" component={InvoiceInfoContainer} />
              <AuthRoute path="/invoice-receiver" component={InvoiceReceiverContainer} />
              <AuthRoute path="/invoice-history" component={InvoiceHistoryContainer} />
              <AuthRoute path="/invoice-detail" component={InvoiceDetailContainer} />

              <Route path="/room-detail" component={RoomDetail} />
              <Route path="/chain-detail" component={ChainDetail} />
              <Route path="/room-type-detail" component={RoomTypeDetail} />
              <AuthRoute path="/book" component={Book} />
              <AuthRoute path="/chain-book" component={ChainBook} />
              <AuthRoute path="/lease-book" component={LeaseBook} />

              <AuthRoute path="/recognition-list" component={RecognitionList} />
              {/* <AuthRoute path="/idcard-recognition" component={IdcardRecognition} />
              <AuthRoute path="/face-recognition" component={FaceRecognition} /> */}

              <AuthRoute path="/main-recognition" component={MainRecognition} />
              <AuthRoute path="/other-recognition" component={OtherRecognition} />

              <Route path="/add-guest" component={AddGuest} />
              {/* <Route path="/delicious" component={Delicious} /> */}
              <Route path="/roomerArticle" component={RoomerArticle} />
              <Route path="/order-detail" component={OrderDetail} />
              <Route path="/travel-guide-list" component={TravelGuideList} />
              <AuthRoute path="/coupons" component={CouponsContainer} />
              <AuthRoute path="/feedback" component={FeedbackContainer} />
              <AuthRoute path="/reset-password" component={ResetPasswordContainer} />
              <AuthRoute path="/open-door" component={OpenDoorContainer} />
              <AuthRoute path="/order-evaluation" component={OrderEvaluation} />
              <AuthRoute path="/clean-evaluation" component={CleanEvaluation} />
              <AuthRoute path="/apply-for-clean" component={ApplyForClean} />
              <AuthRoute path="/checkiner-list" component={CheckinerList} />
              <Route path="/system-upgrade" component={SystemUpgrade} />
              <AuthRoute path="/my-present" component={MyPresent} />
              <AuthRoute path="/my-poster" component={MyPoster} />
              <AuthRoute path="/present-receiver" component={PresentReceiver} />
              <Route path="/iframe-container" component={IFrameContainer} />
              <Route path="/ground-promotion" component={GroundPromotionContainer} />
              <Route path="/xbed-maker" component={XbedMaker} />

              <Route path="/path-find" component={PathFind} />

              <AuthRoute path="/no-one" component={NoOne} />

              <Redirect to={{ pathname: "/" }} />

            </Switch>
            
          </BrowserRouter>
          <Alert />
          <Loading />
          <Toast />
        </div>
      </Provider>,
      document.getElementById("root"),
      resolve
    );
  })

}

/**
 * 获取客服电话
 */
async function getPhone() {
  try {
    const responData = await API.getAppUISetting();
    Local.set('SERVICETELEPHONE', responData.data.serviceTelephone);
  } catch (error) {
    Local.set('SERVICETELEPHONE', '400-666-1111');
  }
}

/**
 * 初始化应用
 */
async function main() {
  // 历史记录不对，清空历史记录
  let historyDataLocal = Local.get(LOCAL_KEYS.CITY_HISTORYDATA) || {};
  let histories = Local.get(LOCAL_KEYS.CITY_HISTORY) || [];
  let isCityCode = true;
  let historyDataLength = Object.keys(historyDataLocal).length;
  if (historyDataLength > 0) {
    for( let key in historyDataLocal){
      if( !historyDataLocal[key].cityCode ){
        isCityCode = false;
        break;
      }
    }
  }
  if( !isCityCode || (histories.length > 0 && historyDataLength === 0) || (histories.length > historyDataLength) ){
    Local.set(LOCAL_KEYS.CITY_HISTORYDATA, {});
    Local.set(LOCAL_KEYS.CITY_HISTORY, []);
    console.log('历史记录不对，清空历史记录');
  } 
  

  // 储存指纹识别功能状态
  let isSupportFingerPrint = getUrlParameterByName('isSupportFingerPrint');
  if (isSupportFingerPrint) await Session.set('isSupportFingerPrint', isSupportFingerPrint)

  // 记录登陆状态 TODO:
  // let fromMiniProgram = getUrlParameterByName('fromMiniProgram');
  // if(!fromMiniProgram) Session.set('toOrderCount', 1);

  //刷新页面 清除微信配置
  Session.remove('wechat-config');

  // 用于蓝主人跳转至Xbed支付 Xbed账号切换至 对应 蓝主人账号
  let token = getUrlParams()._t;
  if (token) {
    window.localStorage.setItem('token', token);
    let data = await API.queryUserInfo(token);
    if (!data.data.retCode) {
      window.localStorage.setItem('user', JSON.stringify(data.data.user));
    }
    else {
      console.error('蓝主人跳转至Xbed，根据url传递的token 不存在')
    }
  }
  
  // 用于无人入住跳转Xbed办理入住页面
  let noOne = getUrlParams();
  if (noOne.token) {
    try {
      let qr = await API.noOneQrCodeUpdate('/api/v1/checkin/refresh_qrcode', {phone: noOne.phone}, noOne.token);
      window.localStorage.setItem('token', noOne.token);
      let data = await API.queryUserInfo(noOne.token);
      if (
        !noOne.expires_at
        || moment().unix() > noOne.expires_at
        || qr.data.retCode
        || (qr.data.scan_times && qr.data.scan_times > 2)
      ) {
        window.localStorage.removeItem('token');
        window.location.href = `${process.env.REACT_APP_URL}app/home${noOne.fromMiniProgram ? noOne.fromMiniProgram : ''}${noOne.isSupportFingerPrint ? noOne.isSupportFingerPrint : ''}`;
      }
      else if (data.data.retCode) {
        alert('您的登陆验证已失效，请联系前台');
        window.localStorage.removeItem('token');
        window.location.href = `${process.env.REACT_APP_URL}app/home${noOne.fromMiniProgram ? noOne.fromMiniProgram : ''}${noOne.isSupportFingerPrint ? noOne.isSupportFingerPrint : ''}`;
      }
      else {
        window.localStorage.setItem('user', JSON.stringify(data.data.user));
      }
    } catch (error) {
      // console.log(error)
      window.location.href = `${process.env.REACT_APP_URL}app/home${noOne.fromMiniProgram ? noOne.fromMiniProgram : ''}${noOne.isSupportFingerPrint ? noOne.isSupportFingerPrint : ''}`;
    }
  } else {
  }

  setupFundebug()

  setupEventEmitter()

  initDateFunc()

  setupInspectPopularize();

  setupVconsole();

  getPhone();

  try {
    /**
     * 渲染页面和获取OpenID没有依赖关系
     * 如果渲染前需要获取OpenID，那么未绑定微信开发者账号的用户在微信开发者工具里面就会无法打开页面
     */
    await renderApp()

    // 1、是否强制在微信浏览器打开 2、当前浏览器是否是微信浏览器
    if (process.env.REACT_APP_WECHAT_FORCE === 'true' || window.isWx) {
      const originUrl = window.location.href.split('#')[0]
      await initWechatOpenID(originUrl)
    }
  } catch (error) {
  }
}

/**
 * 认证路由，如果当前页面需要登录才能访问，改用AuthRoute
 */
export const AuthRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        // 如果有token，允许访问
        const token = Local.get(LOCAL_KEYS.TOKEN);
        if (token) return <Component {...props} />;
        // 没token，登录去~
        return <Redirect to={{ pathname: "/login", from: props.location }} />
      }}
    />
  );
};

/**
 * 迁移型路由
 * 由于3.5和3.6的路由有变化，会影响一些曾经分享二维码的路径跳转
 * 暂时只有房间详情需要做路由兼容
 * 迁移方法可以在路由实现migration方法，入参是location,返回是跳转的路径
 * 
 * 例如，房间详情是直接去掉/app 
 * @example 
 * <MigrationRoute path="/app/room-detail" migration={(location)=>{
 *    return `/room-detail${location.search}`
 * }}/>
 */
export const MigrationRoute = ({ component: Component, ...rest }) => {

  const migrationPath = rest.migration(rest.location)

  // const migrationPath = `${rest.location.pathname.replace(`${rest.replace}`,'')}${rest.location.search}`
  // const migrationPath = rest.migration(rest.location,rest.replace)
  return (
    <Redirect to={migrationPath} />
  )
}
// registerServiceWorker();


main()


// WEBPACK FOOTER //
// ./src/index.js